import { render, staticRenderFns } from "./FlexTable.vue?vue&type=template&id=348ce030"
import script from "./FlexTable.vue?vue&type=script&lang=js"
export * from "./FlexTable.vue?vue&type=script&lang=js"
import style0 from "./FlexTable.vue?vue&type=style&index=0&id=348ce030&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports